// The phone page's own words, in each language readers can choose.
// Ukrainian and Portuguese (Brazilian) are first drafts: have a native speaker check them.

export type Strings = {
  connecting: string;
  notStarted: string;
  live: string;
  paused: string;
  reconnecting: string;
  ended: string;
  waitingTitle: string;
  waitingBody: string;
  machineNote: string;
  feedbackQ: string;
  good: string;
  ok: string;
  poor: string;
  thanks: string;
  jump: string;
  settingsLabel: string;
  display: string;
  language: string;
  textSize: string;
  theme: string;
  dark: string;
  light: string;
  contrast: string;
  done: string;
  closeSheet: string;
  /** Short code on the Aa button and the note: never "UK" for Ukrainian (reads as Britain). */
  code: string;
  /** The Aa button's accessible name. */
  settingsAria: string;
  /** Under a translated language's name in the list, in that language. */
  autoTranslation: string;
  otherLanguages: string;
};

/** Each language's name in that language. */
export const LANG_NAMES: Record<string, string> = {
  en: "English",
  uk: "Українська",
  pt: "Português",
};

export const STRINGS: Record<string, Strings> = {
  en: {
    connecting: "Connecting…",
    notStarted: "Not started",
    live: "Live",
    paused: "Paused · back shortly",
    reconnecting: "Reconnecting…",
    ended: "Ended",
    waitingTitle: "Captions aren’t running right now",
    waitingBody: "Keep this page open. Captions will start automatically when the service begins.",
    machineNote: "",
    feedbackQ: "How were the captions today?",
    good: "Good",
    ok: "OK",
    poor: "Poor",
    thanks: "Thank you, that helps us improve them.",
    jump: "Jump to live ↓",
    settingsLabel: "Language, text size and theme",
    display: "Display",
    language: "Language",
    textSize: "Text size",
    theme: "Theme",
    dark: "Dark",
    light: "Light",
    contrast: "Contrast",
    done: "Done",
    closeSheet: "Close display settings",
    code: "EN",
    settingsAria: "Display and language: English",
    autoTranslation: "",
    otherLanguages: "Other languages",
  },
  uk: {
    connecting: "З’єднання…",
    notStarted: "Ще не почалося",
    live: "Наживо",
    paused: "Пауза · скоро продовжимо",
    reconnecting: "Перепідключення…",
    ended: "Завершено",
    waitingTitle: "Субтитри зараз не транслюються",
    waitingBody: "Не закривайте цю сторінку. Субтитри з’являться автоматично, коли почнеться служіння.",
    machineNote: "Автоматичний переклад з англійської. Можливі неточності.",
    feedbackQ: "Як вам сьогоднішні субтитри?",
    good: "Добре",
    ok: "Так собі",
    poor: "Погано",
    thanks: "Дякуємо, це допоможе нам їх покращити.",
    jump: "До останнього ↓",
    settingsLabel: "Мова, розмір тексту і тема",
    display: "Вигляд",
    language: "Мова",
    textSize: "Розмір тексту",
    theme: "Тема",
    dark: "Темна",
    light: "Світла",
    contrast: "Контраст",
    done: "Готово",
    closeSheet: "Закрити налаштування",
    code: "УКР",
    settingsAria: "Вигляд і мова: українська",
    autoTranslation: "Автоматичний переклад",
    otherLanguages: "Інші мови",
  },
  pt: {
    connecting: "Conectando…",
    notStarted: "Ainda não começou",
    live: "Ao vivo",
    paused: "Em pausa · já voltamos",
    reconnecting: "Reconectando…",
    ended: "Encerrado",
    waitingTitle: "As legendas não estão ativas no momento",
    waitingBody: "Mantenha esta página aberta. As legendas começam automaticamente quando o culto começar.",
    machineNote: "Tradução automática do inglês. Pode conter erros.",
    feedbackQ: "O que você achou das legendas hoje?",
    good: "Boas",
    ok: "Razoáveis",
    poor: "Ruins",
    thanks: "Obrigado, isso nos ajuda a melhorá-las.",
    jump: "Ir para o fim ↓",
    settingsLabel: "Idioma, tamanho do texto e tema",
    display: "Exibição",
    language: "Idioma",
    textSize: "Tamanho do texto",
    theme: "Tema",
    dark: "Escuro",
    light: "Claro",
    contrast: "Contraste",
    done: "Concluído",
    closeSheet: "Fechar configurações",
    code: "PT",
    settingsAria: "Exibição e idioma: português",
    autoTranslation: "Tradução automática",
    otherLanguages: "Outros idiomas",
  },
};

export const t = (lang: string): Strings => STRINGS[lang] ?? STRINGS.en;
